import * as Yup from 'yup';

const validationSchema = () => {
  return Yup.object({
    date: Yup.string().required('tracker.logMeal.input.validationError.empty'),
    time: Yup.string().required('tracker.logMeal.input.validationError.empty'),
    servings: Yup.number()
      .min(0.1, 'tracker.servings.validation.description')
      .max(30, 'tracker.servings.validation.description')
      .required('tracker.logMeal.input.validationError.empty'),
    mealName: Yup.string().max(120, 'tracker.logMeal.mealName.edit.limitReached'),
  });
};

export default validationSchema;
